import usePopupCoordinator from '@/hooks/usePopupCoordinator';
import {selectIsLoyaltyPending, selectLoyaltyPopups} from '@/state/selectors/loyalty';
import {resetLoyaltyPopup} from '@/state/slices/loyaltySlice';

export const useLoyaltyPopupCoordinator = () => {
    usePopupCoordinator(selectIsLoyaltyPending, selectLoyaltyPopups, resetLoyaltyPopup);
};
